/**
 * 身份证信息解析工具函数
 * @param {string} userCard - 身份证号码
 * @param {number} num - 解析类型：1-出生日期，2-性别，3-年龄
 * @param {number|string} backendAge - 后端返回的年龄（可选）
 * @param {number|string} backendSex - 后端返回的性别（可选，1-男，2-女）
 * @returns {string|number} 根据类型返回对应的信息
 */
export function parseIdCard(userCard, num, backendAge = null, backendSex = null) {
  // 参数验证
  if (!userCard || typeof userCard !== 'string') {
    console.warn('身份证号码格式不正确');
    return '';
  }

  // 获取出生日期
  if (num === 1) {
    const birth = 
      userCard.substring(6, 10) +
      "-" +
      userCard.substring(10, 12) +
      "-" +
      userCard.substring(12, 14);
    return birth;
  }

  // 获取性别
  if (num === 2) {
    // 如果后端返回了性别，优先使用后端的
    if (backendSex !== null && backendSex !== undefined && backendSex !== '') {
      if (backendSex == 1) {
        return "男";
      } else if (backendSex == 2) {
        return "女";
      }
    }
    
    // 如果后端没有返回性别或格式不正确，从身份证解析
    if (parseInt(userCard.substr(16, 1)) % 2 === 1) {
      return "男";
    } else {
      return "女";
    }
  }

  // 获取年龄
  if (num === 3) {
    // 如果后端返回了年龄，优先使用后端的
    if (backendAge !== null && backendAge !== undefined && backendAge !== '') {
      return parseInt(backendAge);
    }
    
    // 如果后端没有返回年龄，从身份证解析
    const myDate = new Date();
    const month = myDate.getMonth() + 1;
    const day = myDate.getDate();
    let age = myDate.getFullYear() - userCard.substring(6, 10) - 1;
    
    if (
      userCard.substring(10, 12) < month ||
      (userCard.substring(10, 12) == month &&
        userCard.substring(12, 14) <= day)
    ) {
      age++;
    }
    return age;
  }

  return '';
}

export const idCard = parseIdCard;
